module.exports = __webpack_public_path__ + "img/xjykdyfs.1642ec0c.png";